import { TranslationKey } from './../../../../../../types/translation/TranslationKey';

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OnboardingRoutes } from '../../..';
import { ProductMasterData } from '../../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../../types/translation/Translator';

interface OnboardingReferenceDataItemProps {
  productMasterData: ProductMasterData;
}

export default function OnboardingReferenceDataItem({ productMasterData }: OnboardingReferenceDataItemProps) {
  const navigate = useNavigate();

  return (
    <div className='grid gap-1 bg-gray-100 px-6 py-4'>
      <div className='flex items-center justify-between'>
        <p className='text-sm font-medium text-gray-900'>{productMasterData.productName}</p>

        <div className='flex items-center gap-2'>
          <a
            className='cursor-pointer text-sm font-medium text-primary-600'
            role='button'
            onClick={() => navigate(OnboardingRoutes.referenceDataEdit.replace(':id', productMasterData.id))}
          >
            {t(TranslationKey.edit).singular.label}
          </a>
          <span>|</span>
          <button className='text-sm font-medium text-primary-600'>{t(TranslationKey.delete).singular.label}</button>
        </div>
      </div>
      <p className='text-xs text-gray-600'>{productMasterData.productNumber}</p>
    </div>
  );
}
